import Product_image1 from "../../../assets/images/weed_product.webp";
import Product_image2 from "../../../assets/images/CBD2.webp";
import Product_image3 from "../../../assets/images/CBD3.webp";
import Product_image4 from "../../../assets/images/CBD4.webp";

export const products = [
  {
    title: "Flower",
    description:
      "3.5 grams of exceptional CREATE Flowers rich in CBD. 100% Swiss-Made. Tobacco and nicotine free.",
    price: "300",
    image: Product_image1,
  },
  {
    title: "Pre-Rolled",
    description:
      "3.5 grams of exceptional CREATE Flowers rich in CBD. 100% Swiss-Made. Tobacco and nicotine free.",
    price: "300",
    image: Product_image2,
  },
  {
    title: "CBD OIL",
    description:
      "3.5 grams of exceptional CREATE Flowers rich in CBD. 100% Swiss-Made. Tobacco and nicotine free.",
    price: "300",
    image: Product_image3,
  },
  {
    title: "Refil",
    description:
      "3.5 grams of exceptional CREATE Flowers rich in CBD. 100% Swiss-Made. Tobacco and nicotine free.",
    price: "300",
    image: Product_image4,
  },
  {
    title: "Flower",
    description:
      "3.5 grams of exceptional CREATE Flowers rich in CBD. 100% Swiss-Made. Tobacco and nicotine free.",
    price: "300",
    image: Product_image1,
  },
  {
    title: "Pre-Rolled",
    description:
      "3.5 grams of exceptional CREATE Flowers rich in CBD. 100% Swiss-Made. Tobacco and nicotine free.",
    price: "300",
    image: Product_image2,
  },
  {
    title: "CBD OIL",
    description:
      "3.5 grams of exceptional CREATE Flowers rich in CBD. 100% Swiss-Made. Tobacco and nicotine free.",
    price: "300",
    image: Product_image3,
  },
  {
    title: "Refil",
    description:
      "3.5 grams of exceptional CREATE Flowers rich in CBD. 100% Swiss-Made. Tobacco and nicotine free.",
    price: "300",
    image: Product_image4,
  },
  {
    title: "CBD OIL",
    description:
      "3.5 grams of exceptional CREATE Flowers rich in CBD. 100% Swiss-Made. Tobacco and nicotine free.",
    price: "300",
    image: Product_image3,
  },
  {
    title: "Refil",
    description:
      "3.5 grams of exceptional CREATE Flowers rich in CBD. 100% Swiss-Made. Tobacco and nicotine free.",
    price: "300",
    image: Product_image4,
  },
];
